import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  ButtonsContainerComponent,
  PipesModule,
  TypedFormControl,
} from '@principle-theorem/ng-shared';
import { IAttachment, isSameRef, WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-moh-approval-request-attachments-dialog',
  imports: [
    MatToolbarModule,
    ButtonsContainerComponent,
    MatButton,
    MatListModule,
    MatIconModule,
    CommonModule,
    ReactiveFormsModule,
    PipesModule,
    MatDividerModule,
  ],
  templateUrl: './moh-approval-request-attachments-dialog.component.html',
  styleUrl: './moh-approval-request-attachments-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohApprovalRequestAttachmentsDialogComponent {
  dialogRef =
    inject<
      MatDialogRef<
        MohApprovalRequestAttachmentsDialogComponent,
        WithRef<IAttachment>[]
      >
    >(MatDialogRef);
  attachments = inject<WithRef<IAttachment>[]>(MAT_DIALOG_DATA);
  selectedCtrl = new TypedFormControl<WithRef<IAttachment>[]>([]);
  compareFn = isSameRef;

  getIcon(fileType: string): string {
    if (fileType.startsWith('image/')) {
      return 'image';
    }
    if (fileType.includes('pdf')) {
      return 'picture_as_pdf';
    }
    if (fileType.includes('zip') || fileType.includes('archive')) {
      return 'archive';
    }
    return 'description';
  }
}
